<script setup>
import { ref } from 'vue'
import { register } from 'swiper/element/bundle'
register()

const props = defineProps({
	reverse: {
		type: Boolean,
		default: false,
	},
	background: {
		type: String,
		default: '#080808',
	},
})

const tickerItems = ref([
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/paper-crowns.svg',
		alt: 'Paper Crowns Logo',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/crossed-swords.png',
		alt: 'Paper Crowns Tower',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/visionaries.svg',
		alt: 'Paper Crowns Tower',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/pc-re.svg',
		alt: 'PC-RE Pills',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/reimagine-everything.svg',
		alt: 'Reimagine Everything',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/tower.png',
		alt: 'Paper Crowns Tower',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/est-2019.svg',
		alt: 'Established 2019',
	},
	{
		image: 'https://cdn.papercrowns.com/website/images/elements/ticker/20-19.svg',
		alt: '20-19 Pills',
	},
])
</script>

<template>
	<div class="group relative h-20 overflow-hidden" :style="`background: ${background};`">
		<div class="flex h-full w-full gap-8 py-3" style="animation: marquee 90s linear infinite">
			<template v-for="i in 20">
				<img v-for="item in tickerItems" class="h-full opacity-30" :src="item.image" :alt="item.alt" />
			</template>
		</div>
	</div>
</template>

<style scoped>
@keyframes marquee {
	0% {
		transform: translate3d(0, 0, 0);
	}
	100% {
		transform: translate3d(-400%, 0, 0);
	}
}
</style>
